<template>
  <SvgBase iconName="Checkbox" width="14" height="14">
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9583 4.60444L10.8617 3.5L5.73611 8.62556L3.72944 6.62667L2.625 7.72333L5.73611 10.8267L11.9583 4.60444Z"
        :fill="color"
      />
      <rect x="0.5" y="0.5" width="13" height="13" rx="2.5" :stroke="color" />
    </svg>
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from '../SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconCheckbox extends Vue {}
</script>
